import React from "react";
import { Fields } from "redux-form";
import translateProps from "./translateProps";

export default function withFormFields(Component, fields = []) {
  function WithFormFields({ ...rest }) {
    return <Fields names={fields} component={Component} {...rest} />;
  }

  return WithFormFields;
}

export const withFormFieldsByKey = (Component, fields = {}) => {
  const TranslatedComp = translateProps(props =>
    Object.keys(fields).reduce(
      (prev, current) => ({
        ...prev,
        [fields[current]]: props[current]
      }),
      {}
    )
  )(Component);

  return withFormFields(TranslatedComp, Object.keys(fields));
};



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/withFormFields.jsx